import React, { useCallback } from "react";
import { Input, InputProps, InputOnChangeData } from "semantic-ui-react";

import { Cep, Currency, Cpf, Data, Hora, Celular } from "./masks";

interface MaskedInputProps extends InputProps {
    mask: "cep" | "currency" | "cpf" | "data" | "hora" | "celular";
}

const MaskedInput: React.FC<MaskedInputProps> = ({ mask, ...props }) => {

    const handleKeyUp = useCallback(
        (inputElement: React.FormEvent<HTMLInputElement>) => {
            switch (mask) {
                case "cep":
                    Cep(inputElement);
                    break;
                case "cpf":
                    Cpf(inputElement);
                    break;
                case "currency":
                    Currency(inputElement);
                    break;
                case "data":
                    Data(inputElement);
                    break;
                case "hora":
                    Hora(inputElement);
                    break;
                case "celular":
                    Celular(inputElement);
                    break;
            }

            return inputElement;
        },
        [mask]
    );

    const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>, data: InputOnChangeData) => {
        const input = handleKeyUp(event);
        data.value = input.currentTarget.value;

        if (props.onChange) {
            props.onChange(event, data);
        }
    }

    return (
        <Input
            {...props}
            onChange={handleOnChange}
        />
    );
};

export default MaskedInput;
